let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("4Oj5y"), load("c6gxD"), load("3UR1K"), load("3b99S"), load("9wTW2")]).then(() => parcelRequire('dFOTO'));